import axios from "axios";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";
import { UserPreferences } from "../../types/ui";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const updateUserPreferences = async (
  accountId: number,
  userId: number,
  preferences: UserPreferences,
): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.put(
    `${BASE_URL}/${accountId}/users/${userId}/preferences`,
    { preferences },
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};